export default "__VITE_ASSET__da7def33__"